// @ts-nocheck

export function openRocketChat() {
    RocketChat(function() {
        this.showWidget();
        this.maximizeWidget();
    });
}

export function setUserData(username: string, email: string) {
    RocketChat(function() {
        this.setGuestName(username);
        this.setGuestEmail(email);
    });
}